import { cx } from "../../lib/cx.js";
/* empty css                    */
import { jsx, jsxs } from "react/jsx-runtime";
//#region src/components/DescriptionList/DescriptionList.tsx
/**
* Terms and their values as a `<dl>`, each pair in a `<div>`. Native attributes go on
* the `<dl>`.
*/
function DescriptionList({ items, layout = "row", columns = 1, className, style, ...rest }) {
	const columnStyle = layout === "stacked" ? { "--_columns": Math.max(1, Math.floor(columns)) } : void 0;
	return /* @__PURE__ */ jsx("dl", {
		className: cx("ds-dl", `ds-dl--${layout}`, className),
		style: {
			...columnStyle,
			...style
		},
		...rest,
		children: items.map((item, index) => /* @__PURE__ */ jsxs("div", {
			className: "ds-dl__row",
			children: [/* @__PURE__ */ jsx("dt", {
				className: "ds-dl__term",
				children: item.term
			}), /* @__PURE__ */ jsx("dd", {
				className: "ds-dl__description",
				children: item.description
			})]
		}, item.key ?? index))
	});
}
//#endregion
export { DescriptionList };

//# sourceMappingURL=DescriptionList.js.map